export default __webpack_public_path__ + "static/media/ic_link_40.9db627fc.svg";